export const useShippingPendingFooter = () => {
  return {};
};
